export default __webpack_public_path__ + "static/media/396hz-Root-Chakra.8fc165ed.mp3";